"use client"

import LottiePlayer from "@/ui/common/bit/LottiePlayer"
import { isLottieFile } from "@/ui/common/bit/isLottieFile"
import { sendBlockEvent } from "@/utils/gtm"
import styled from "@emotion/styled"
import { Box } from "@mui/material"
import Image from "next/image"
import { mediaQueries, useIsDesktop } from "ui"
import { getUmbracoMediaUrl } from "utils"
import BlockWrapper from "../common/BlockWrapper"
import ListProductsSelect from "./ListProductsSelect"

const StyledBackgroundImageContainer = styled(Box)`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
  ${mediaQueries.mobile} {
    top: -110px;
  }

  ${mediaQueries.tablet} {
    top: -110px;
  }

  ${mediaQueries.desktopM} {
    width: 230%;
    height: 230%;
    top: -6%;
    right: -60%;
  }
`

const StyledImages = styled(Box)`
  position: absolute;
  ${mediaQueries.mobile} {
    inset: auto auto -100px -115px;
    width: 480px;
    height: 300px;
  }

  ${mediaQueries.tablet} {
    inset: auto auto -100px -115px;
    width: 480px;
    height: 300px;
  }

  ${mediaQueries.desktopM} {
    inset: 0 auto auto -250px;
    width: 800px;
    height: 100%;
  }
`
const StyledImageContainer = styled(Box)`
  position: absolute;
  inset: auto 0 0;
  width: 100%;
  bottom: 110px;
  height: 190px;
  img {
    object-fit: contain;
  }

  ${mediaQueries.desktopM} {
    height: 277px;
    bottom: 80px;
  }
`

const ProductCarInsuranceBillingComponent = ({ data, id }: any) => {
  const { itemsList, image } = data
  const isDesktop = useIsDesktop()

  const handleCardClick = (buttonTitle: string) => {
    sendBlockEvent({
      blockId: id || "1",
      title: "",
      componentName: "הוספת כיסויים",
      productName: data?.productName || data?.formDefaultInsuranceType,
      buttonName: buttonTitle,
    })
  }

  return (
    <BlockWrapper
      id={id}
      style={
        isDesktop
          ? { justifyContent: "center" }
          : { alignItems: "center", paddingBottom: "160px" }
      }
    >
      <ListProductsSelect itemsList={itemsList} onTabClick={handleCardClick} />
      <StyledImages>
        <StyledBackgroundImageContainer>
          <Image
            fill
            src={isDesktop ? "/bgHachsharaShapeDesktop.svg" : "/shape.svg"}
            alt="bgHachsharaShapeDesktop"
          />
        </StyledBackgroundImageContainer>
        {image && image?.mediaItems && image?.mediaItems[0]?.url && (
          <StyledImageContainer>
            {isLottieFile(image.mediaItems[0].url) ? (
              <LottiePlayer
                lottieUrl={getUmbracoMediaUrl(image.mediaItems[0].url)}
                playOnce={true}
                autoplay={true}
                loop={false}
                ariaLabel={
                  image.mediaItems?.[0]?.alt ||
                  "Product Car Insurance Billing image"
                }
                style={{ width: "100%", height: "100%" }}
              />
            ) : (
              <Image
                fill
                src={getUmbracoMediaUrl(image.mediaItems?.[0].url)}
                alt={
                  image.mediaItems?.[0]?.alt ||
                  "Product Car Insurance Billing image"
                }
              />
            )}
          </StyledImageContainer>
        )}
      </StyledImages>
    </BlockWrapper>
  )
}

export default ProductCarInsuranceBillingComponent
